import React, { FC, useEffect, useState } from "react";
import { Box, List } from "@mui/material";
import styled from "@emotion/styled";
import HomePatientSelect from "@components/Home/HomePatientSelect/HomePatientSelect";
import NestedMenuItem from "@components/SideBar/NesttedMenuItem";
import Item from "@components/SideBar/Item";
import { useLocation } from "react-router-dom";
import Menu from "@constants/menu";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { Mode } from "@store/homeSlice";
import AccountSetupProgressButton from "@components/AccountSetupProgressButton";

const SideBarContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  box-sizing: border-box;
  transition: width 225ms cubic-bezier(0.4, 0, 0.6, 1);
  padding: 16px 4px;
`;

const PatientInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  width: 180px;
  max-width: 100%;
`;

interface SideBarProps {
  compact?: boolean;
  onNavigate?: () => void;
}

const SideBar: FC<SideBarProps> = ({ compact = false, onNavigate }) => {
  const isPatient = useSelector(
    (state: RootState) => state.auth.user?.isPatient,
  );
  const location = useLocation();
  const mode = useSelector((state: RootState) => state.home.mode);

  const [activeItem, setActiveItem] = useState<string | null>(null);

  useEffect(() => {
    setActiveItem(location?.pathname || "");
  }, [location]);

  return (
    <SideBarContainer
      sx={{
        width: compact ? "64px" : "280px",
        color: "grey.800",
      }}
    >
      {!compact && !isPatient && (
        <>
          <PatientInfo>
            {mode === Mode.Caregiver && <HomePatientSelect />}
          </PatientInfo>
        </>
      )}

      <List sx={{ width: "100%" }}>
        {Menu[mode].map((props) =>
          props.children ? (
            <NestedMenuItem
              id={props.id}
              key={props.id || props.title}
              {...props}
              compact={compact}
              selectedItem={activeItem}
              onNavigate={onNavigate}
            />
          ) : (
            <Item
              id={props.id}
              key={props.id || props.title}
              {...props}
              compact={compact}
              selected={
                props.exact
                  ? activeItem === props.path
                  : !!activeItem?.includes(props.path, 0)
              }
              onNavigate={onNavigate}
            />
          ),
        )}
      </List>

      {mode === Mode.Caregiver && (
        <Box
          marginTop="auto"
          width="100%"
          display="flex"
          justifyContent="center"
          padding={compact ? undefined : "0 16px"}
          boxSizing="border-box"
        >
          <AccountSetupProgressButton compact={compact} onOpen={onNavigate} />
        </Box>
      )}
    </SideBarContainer>
  );
};

export default SideBar;
